/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Return a list of all users.
 */
export const SearchRetrieveQueryParams = zod.object({
  "query": zod.string().optional().describe('Search term; must be at least 3 characters to match.')
})

export const searchRetrieveResponseContractsItemNameMax = 255;

export const searchRetrieveResponseInvoicesItemNumberMax = 100;

export const searchRetrieveResponseTicketsItemNumberMax = 20;



export const SearchRetrieveResponse = zod.object({
  "cars": zod.array(zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "property": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid()
}).strict()
}).strict()),
  "contracts": zod.array(zod.object({
  "name": zod.string().max(searchRetrieveResponseContractsItemNameMax),
  "id": zod.string().uuid()
}).strict()),
  "invoices": zod.array(zod.object({
  "number": zod.string().max(searchRetrieveResponseInvoicesItemNumberMax),
  "id": zod.string().uuid(),
  "property": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid()
}).strict().nullable()
}).strict()),
  "properties": zod.array(zod.object({
  "name": zod.string(),
  "id": zod.string().uuid()
}).strict()),
  "tickets": zod.array(zod.object({
  "number": zod.string().max(searchRetrieveResponseTicketsItemNumberMax),
  "id": zod.string().uuid(),
  "property": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid()
}).strict().nullable()
}).strict())
}).strict()

